import PropTypes from 'prop-types'
import React from 'react'
import useLocale from 'js/hooks/useLocale'
import { kilogramsToPounds } from 'js/metricsConverter'

function getUnit(language, country) {
  if (language == 'en' && (country === 'US' || country === 'GB')) return 'lbs'
  if (language === 'ru') return 'кг'
  return 'kg'
}

function FormattedWeight({ weightInKg }) {
  const { language, country } = useLocale()
  const unit = getUnit(language, country)

  return (
    <>
      {unit === 'lbs' ? kilogramsToPounds(weightInKg) : weightInKg}&nbsp;
      {getUnit(language, country)}
    </>
  )
}

export default FormattedWeight

FormattedWeight.propTypes = {
  weightInKg: PropTypes.number.isRequired,
}
